import { Link } from "react-router-dom";
import { featuredComic } from "@/mocks/comics";

const steps = [
  {
    icon: "ri-search-line",
    title: "找到喜欢的漫画",
    desc: "通过分类、榜单或搜索，快速定位你想追的连载作品。",
  },
  {
    icon: "ri-bookmark-line",
    title: "收藏开启追更",
    desc: "点击「追更」收藏作品，更新后第一时间收到提醒。",
  },
  {
    icon: "ri-flashlight-fill",
    title: "第一时间看最新话",
    desc: "最新话上线即刻推送，剧情进展不落后、不迷路。",
  },
];

export default function SpotlightSection() {
  return (
    <section className="bg-secondary-50 py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10 items-center">
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-3xl overflow-hidden aspect-[4/5] max-w-md mx-auto lg:mx-0 bg-background-100">
              <img
                src={featuredComic.cover}
                alt={`本周焦点连载 ${featuredComic.title} 最新话更新`}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/80 to-transparent p-4">
                <span className="text-[10px] text-accent-300">本周焦点连载</span>
                <h3 className="font-heading text-xl text-background-50">{featuredComic.title}</h3>
                <p className="mt-1 text-xs text-background-200">{featuredComic.latestChapter}</p>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <span className="inline-flex items-center gap-1.5 text-xs font-medium text-secondary-700 bg-secondary-100 px-3 py-1 rounded-full">
              <i className="ri-quill-pen-fill"></i>轻松三步追更
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">追更，其实很简单</h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              无论你是喜欢日漫还是国漫，天天漫画网都能帮你把追更这件事安排得明明白白。三步上手，从此不再错过任何一话精彩剧情。
            </p>

            <div className="mt-7 space-y-4">
              {steps.map((s, idx) => (
                <div key={idx} className="flex gap-4 items-start rounded-2xl bg-background-50 border border-background-200 p-4">
                  <span className="w-11 h-11 shrink-0 rounded-xl bg-secondary-500 text-background-50 flex items-center justify-center">
                    <i className={`${s.icon} text-lg`}></i>
                  </span>
                  <div>
                    <h3 className="text-sm font-medium text-foreground-900">
                      <span className="text-secondary-600 font-bold mr-1">{idx + 1}.</span>
                      {s.title}
                    </h3>
                    <p className="mt-1 text-xs md:text-sm text-foreground-500">{s.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <Link
                to="/latest"
                className="inline-flex items-center justify-center gap-1.5 h-11 px-6 rounded-full bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors"
              >
                去看今日更新 <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to={`/comic/${featuredComic.id}`}
                className="inline-flex items-center justify-center gap-1.5 h-11 px-6 rounded-full bg-background-50 border border-background-300 text-foreground-800 text-sm font-medium whitespace-nowrap hover:border-primary-300 hover:text-primary-700 transition-colors"
              >
                了解本周焦点
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}